/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Slim_Jay_RaceInputs */

const en_bright_slim_jay_race = /** @type {(inputs: Bright_Slim_Jay_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import new participation groups for this round from a CSV file.`)
};

const de_bright_slim_jay_race = /** @type {(inputs: Bright_Slim_Jay_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importiere neue Teilnahmegruppen für diese Runde mit einer CSV-Datei.`)
};

/**
* | output |
* | --- |
* | "Import new participation groups for this round from a CSV file." |
*
* @param {Bright_Slim_Jay_RaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bright_slim_jay_race = /** @type {((inputs?: Bright_Slim_Jay_RaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Slim_Jay_RaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bright_slim_jay_race(inputs)
	return de_bright_slim_jay_race(inputs)
});